import React from "react";
import CloudStorageScreen from "../screens/CloudStorageScreen";

const CloudRouter = (props: any) => {
  return <CloudStorageScreen {...props} />;
};

export default CloudRouter;
